module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-800-97ae8f0f4c3d743a27496689665416bc.ttf";